import React from 'react'

interface IconProps {
  className?: string
}

export const IngredientIcon: React.FC<IconProps> = ({ className }) => {
  return (
    <svg 
      width="24" 
      height="24" 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path 
        d="M7.99997 2H16M7.99997 13H16M9.99997 2H14V7.52786C14 7.83835 14.0723 8.14458 14.2111 8.42229L19.5528 19.1056C20.2177 20.4354 19.2507 22 17.7639 22H6.23604C4.74928 22 3.78228 20.4354 4.44719 19.1056L9.78883 8.42229C9.92768 8.14458 9.99997 7.83835 9.99997 7.52786V2Z" 
        stroke="currentColor" 
        strokeWidth="1.5" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  )
}